import { useSearch } from '@/apis/searches';
import { NotRenewingContext } from '@/App';
import { usePrecacheUserContactPerms } from '@hooks/useCaching';
import { CircularProgressLoadingPage } from '@pages/CircularProgressLoadingPage';
import { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import QuickFilterListCreatorPage from '.';
import { FilterCriteria } from './filterCriteriaReducer';
import { useLoadQuickFilter } from './useQuickFilterLoader';

export { usePrefetchQuickFilter } from './useQuickFilterLoader';

export const QuickSearchLoader = () => {
  const { searchId } = useParams();
  const { data: searchData, isLoading } = useSearch(Number(searchId));
  const { setNotRenewingPresent } = useContext(NotRenewingContext);

  usePrecacheUserContactPerms();

  const { data: initialFilterCriteria, isFetching } = useLoadQuickFilter(
    searchData?.type === 'Quick' ? ((searchData.data as FilterCriteria | undefined) ?? null) : null,
    searchData?.metadata.id
  );

  const isWaitingForFinalStatus = isFetching || isLoading || !searchData || !initialFilterCriteria;

  useEffect(() => {
    if (!isWaitingForFinalStatus) {
      setNotRenewingPresent(
        ['onlyInclude', 'exclude'].includes(initialFilterCriteria?.filterCriteria.notRenewing)
      );
    }
  }, [
    initialFilterCriteria?.filterCriteria.notRenewing,
    isWaitingForFinalStatus,
    setNotRenewingPresent,
  ]);

  return isWaitingForFinalStatus ? (
    <CircularProgressLoadingPage />
  ) : (
    <>
      <QuickFilterListCreatorPage
        loadedFilterCriteria={initialFilterCriteria.filterCriteria}
        loadedAccordionStates={initialFilterCriteria.accordionStates}
        missingFilters={initialFilterCriteria.missingFilters}
        loadedMetadata={searchData?.metadata}
      />
    </>
  );
};
